import React, { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { beginReset, ResetPayload } from "../../redux/actions/auth/reset";
import { RESET_BEGIN_RESET } from "../../redux/actionTypes/actionsTypes";
import { ResetPasswordResponse } from "../../redux/reducers/getAuthReducer/resetPasswordReducer";
import { RootState } from "../../redux/reducers/root";
import extractFormData from "../../utils/extractFormData";
import AmpButton from "../common/AmpButton/AmpButton";
import AmpCaptcha from "../common/AmpCaptcha/AmpCaptcha";
import AmpFormError from "../common/AmpFormError/AmpFormError";
import AmpInput from "../common/AmpInput/AmpInput";
import AmpLoadingSpinner from "../common/AmpLoadingSpinner/AmpLoadingSpinner";
import SmallHeading from "../common/AmpSmallHeading/AppSmallHeading";

interface ResetStep1Props {
    nextStep: (question: string, questionId: number, userProfileId: string, email: string) => void,
    cancel: () => void
}

export default function ResetStep1(props: ResetStep1Props) {
    const { t } = useTranslation("login");
    const dispatch = useDispatch();
    const resetStore = useSelector((state: RootState) => state.authReducer.reset.question as ResetPasswordResponse);
    const [captchaKey, setCaptchaKey] = useState(1);
    const [email, setEmail] = useState('');

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setCaptchaKey(captchaKey + 1);
        dispatch({type: RESET_BEGIN_RESET})
        const data = extractFormData(e) as ResetPayload;
        setEmail(data.search);
        dispatch(beginReset(data))
    }

    if (resetStore.found && !resetStore.loading && resetStore.user_profile_id && resetStore.security_q && email) {
        props.nextStep(resetStore.security_q as string, resetStore.question_id as number,  resetStore.user_profile_id as string, email);
        return <></>
    }

    const cancel = (e: FormEvent) => {
        e.preventDefault();
        setEmail('');
        props.cancel();
    }

    return (
        <div className="reset-container fade">
            <div className="reset-header">
                {t("verify-acc") as string}
            </div>

            <AmpLoadingSpinner loading={resetStore.loading}>
                <form className="reset-content-top" onSubmit={(e) => { handleSubmit(e) }}>
                    <div className="reset-content">
                        <SmallHeading for={"reset-email"}>
                            {t("enter-email-uid") as string}
                        </SmallHeading>
                        <AmpInput type="text" name="search" id="reset-email" />
                        <AmpCaptcha key={captchaKey} />
                    </div>
                    <AmpFormError errorMessage={t("user-not-found")} error={resetStore.found === false && !resetStore.loading}></AmpFormError>
                    <div className="login-container-footer">
                        <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/auth/contact-us">{t("need-help") as string}</Link>
                        <div>
                            <AmpButton type="cancel" onClick={(e) => cancel(e)} text={t("cancel")} />
                            <AmpButton type="submit" onClick={() => null} text={t("search")} />
                        </div>
                    </div>

                </form>
            </AmpLoadingSpinner>
        </div>
    )
}